import { createFileRoute } from '@tanstack/react-router';
import { QuickbarView } from '@/features/quickbar/QuickbarView';

// quickbar 是 Tauri 独立 webview 加载的弹层路由 —— 不挂 AppShell（无 sidebar / header）
export const Route = createFileRoute('/quickbar')({
  component: QuickbarPage,
});

function QuickbarPage() {
  return <QuickbarView />;
}
